import { Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import Slider from 'react-slick';

import RichText, { domToReact } from '@/components/RichText/RichText';
import VideoTestimonialTile from '@/components/ui/VideoTestimonialTile/VideoTestimonialTile';
import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

import Arrow from './lib/Arrow';
import { SliderWrapper, Wrapper } from './VideoTestimonials.style';

const richTextReplacer = (element, wrappedReplacer) => {
  if (element.name === 'h2' && element.children.length) {
    return (
      <Typography variant="h2" textAlign="center" mb={{ xs: 4, md: 0 }}>
        {domToReact(element.children, { replace: wrappedReplacer })}
      </Typography>
    );
  }

  return null;
};

/**
 * VideoTestimonials.
 */
const VideoTestimonials = ({ testimonials, headline }) => {
  const sliderRef = useRef(null);

  const mobileMediaQuery = useMobileMediaQuery();

  const sliderOptions = {
    dots: true,
    arrow: true,
    rows: 1,
    lazyLoad: true,
    infinite: false,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots',
    prevArrow: (
      <Arrow direction="left" onClick={() => sliderRef.current.slickPrev()} />
    ),
    nextArrow: <Arrow onClick={() => sliderRef.current.slickNext()} />,
  };

  return (
    <Wrapper data-test-subject="video-testimonial-wrapper">
      <RichText data={headline} replace={richTextReplacer} />
      <SliderWrapper>
        <Slider {...sliderOptions} ref={sliderRef}>
          {testimonials.map((t, i) => (
            <VideoTestimonialTile
              key={`${i}${t.image?.alt ?? ''}`}
              image={t.image}
              content={t.content}
              logo={t.logo}
              video={t.video}
              bigImage={t.bigImage}
              personName={t.personName}
              companyName={t.companyName}
            />
          ))}
        </Slider>
      </SliderWrapper>
      {mobileMediaQuery && (
        <Box mt={4.5}>
          <Divider />
        </Box>
      )}
    </Wrapper>
  );
};

VideoTestimonials.propTypes = {
  /** Headline */
  headline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]),
  /** Testimonials list to be displayed */
  testimonials: PropTypes.arrayOf(PropTypes.object).isRequired,
};

VideoTestimonials.defaultProps = {
  headline: '',
};

export default VideoTestimonials;
